import {WhitelabelEvent, WhitelabelEventWithPayload} from "../events/Events";
import {EventBus} from "../events/EventBus";
let eventBus;
let storage: Storage;

function getItem(key: string): string | null {
    return storage.getItem(key);
}

interface SetItemPayload {
    key: string,
    value: string,
}

export class SetItemEvent implements WhitelabelEventWithPayload<SetItemPayload> {
    payload: SetItemPayload;
    type: string;
    static readonly TYPE: string = 'local-storage-set-item';

    constructor(payload: SetItemPayload) {
        this.type = SetItemEvent.TYPE;
        this.payload = payload;
    }
}

export function localStorageSetItem(event: WhitelabelEvent) {
    const {payload: {key, value}} = (event as SetItemEvent);

    storage.setItem(key, value);
}

function init(ls: any = globalThis.localStorage, ev = EventBus.getInstance()) {
    storage = ls;
    eventBus = ev;
    eventBus.subscribeWithId(
        SetItemEvent.TYPE,
        {
            id: `${SetItemEvent.TYPE}-handler`,
            callback: localStorageSetItem
        }
    );
}

export default {
    getItem,
    SetItemEvent,
    init,
}